import * as Raven from 'raven-js';
import * as React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import App from './App';
// import generateManifest from './generateManifest';
// @ts-ignore
import { registerServiceWorker, unregister } from './serviceWorker';
import store from './store';

// generateManifest();

if (process.env.NODE_ENV === 'development') {
  unregister();
} else {
  registerServiceWorker();
}

Raven.config(
  'https://33ba15d86acb418f8ad37b4b82f78152@sentry.io/1275248',
).install();

process.on('uncaughtException', event => Raven.captureException(event));
process.on('unhandledRejection', event => Raven.captureException(event));

render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root'),
);



// WEBPACK FOOTER //
// ./src/index.tsx